import { render, staticRenderFns } from "./IntroSlides.vue?vue&type=template&id=2fc2d68a&scoped=true&lang=pug"
import script from "./IntroSlides.vue?vue&type=script&lang=js"
export * from "./IntroSlides.vue?vue&type=script&lang=js"
import style0 from "./IntroSlides.vue?vue&type=style&index=0&id=2fc2d68a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc2d68a",
  null
  
)

export default component.exports